import http from '@/utils/services/http'

export default {
  lista (limit, page, filtros) {
    let url = '/api/usuarios?page=' + page + '&limit=' + limit + filtros
    return http.get(url)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  find (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/usuarios/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  cadastro (data, id) {
    if (typeof id !== 'undefined') {
      return this.atualizacao(data, id)
    }
    return http.post('/api/usuarios/', data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  atualizacao (data, id) {
    return http.patch('/api/usuarios/' + id, data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deletar (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.delete('/api/usuarios/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  alterarSenha (senha, id) {
    return http.patch('/api/usuarios/' + id + '/password', senha)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/usuarios/services/index.js